<template>
  <div class="forms-and-filters">
    <div class="panel-group accordion" id="accordion1">
      <div class="panel panel-default">
        <div class="panel-heading">
          <h4 class="panel-title">
            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion1"
               href="#collapse_1">Forms <i class="pull-right fa"></i></a>
          </h4>
        </div>
        <div id="collapse_1" class="panel-collapse collapse">
          <div class="panel-body">
            <section v-for="form in reportForms">{{form}}</section>
          </div>
        </div>
      </div>
    </div>
    <div class="panel-group accordion" id="accordion2">
      <div class="panel panel-default">
        <div class="panel-heading">
          <h4 class="panel-title">
            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion2"
               href="#collapse_2">Filters <i class="pull-right fa"></i></a>
          </h4>
        </div>
        <div id="collapse_2" class="panel-collapse collapse">
          <div class="panel-body">
            <template v-if="noFilters">No filters applied</template>
            <template v-for="(formFilters, formName) in reportFilters">
              <template v-if="Object.keys(formFilters).length !== 0">
                <strong>{{formName}}</strong>{{formFilters.hasOwnProperty('isNull') ? (formFilters.isNull ? ' is null' : ' is not null') : ''}}
              </template>
              <ul>
                <li v-for="(filters, fieldName) in formFilters.fieldsFilters" v-if="filters.length">{{fieldName}}
                  <ul>
                    <li v-for="filter in filters"><span v-html="filter"></span></li>
                  </ul>
                </li>
              </ul>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash';

  export default {
    props: ['reportData'],
    data() {
      return {
        reportForms: [],
        reportFilters: [],
        noFilters: true
      }
    },
    mounted() {
      this.reportForms = this.getReportForms(this.reportData);
      this.reportFilters = this.getReportFilters(this.reportData);
    },
    methods: {
      getReportForms: function(reportData) {
        let forms = [];
        _.forEach(reportData, function(item) {
          forms.push(item.form_name)
        });
        return forms;
      },
      getReportFilters: function(reportData) {
        let filters = {};
        let fieldsFilters = {};
        // let formatDateFn = this.$options.filters.formatDateModal;
        let formatDateFn = this.$options.filters.formatDateModalNoTimeZone;

        let condTypes = {
          'equals' : 'equals',
          'notequal': 'not equal',
          'startswith': 'starts with',
          'between': 'between',
          'contains': 'contains',
          'notcontain': 'does not contain',
          'lessthan': 'less than',
          'greaterthan': 'greater than',
          'lessorequal': 'less or equal',
          'greaterorequal': 'greater or equal to',
          'recent': 'most recent',
          'isempty': 'is empty',
          'isfilled': 'is filled',
          'today': 'today',
          'thisweek': 'this week',
          'thismonth': 'this month',
          'thisyear': 'this year',
          'birthmonth': 'birth month',
          'unduplicated' : ''
        };

        let self = this;

        _.forEach(reportData, function(item) {

          fieldsFilters = {};


          _.forEach(item.fields, function (field) {

            if (field.hasOwnProperty('conditions')) {
              fieldsFilters[field.label] = [];

              _.forEach(field.conditions, function (condition) {
                if (condition.hasOwnProperty('type') && condition.type !== '') {
                  let condVal = '';
                  if(condition.value) {
                    condVal = condition.value
                  }

                  if (condition.type == 'between') {
                    condVal = condition.value[0] + '-' + condition.value[1]
                  }

                  if (condition.type == 'unduplicated') {
                    condVal = '<strong>is unduplicated</strong>'
                  }

                  if (condition.type == 'recent') {
                    let fieldName = condition.value;
                    let field = _.find(item.fields, {'field': fieldName});

                    if(condition.hasOwnProperty('label')) {
                      condVal = condition.label;
                    }
                    else if(field !== undefined) {
                      condVal = field.label;
                    } else {
                      condVal = '';
                    }
                  }

                  if (condition.type !== '') {
                    fieldsFilters[field.label].push(
                      field.label + ' ' + condTypes[condition.type] + ' ' + '<strong>' + condVal + '</strong>'
                    );
                  }
                }

                if (condition.hasOwnProperty('date') && condition.date !== '') {

                  let condVal = condition.value || '';

                  if (condition.date == 'between') {
                    let date1 = formatDateFn(condition.value[0])
                    let date2 = formatDateFn(condition.value[1])
                    condVal = date1 + '-' + date2
                  }

                  fieldsFilters[field.label].push(
                    field.label + ' ' + condTypes[condition.date] + ' <strong>' + condVal + '</strong>'
                  );

                }
              });

              if (fieldsFilters[field.label].length > 1) {
                if (field.hasOwnProperty('allConditions') && field.allConditions === true) {
                  fieldsFilters[field.label].push('All of the above conditions meet');
                } else {
                  fieldsFilters[field.label].push('Any of the above conditions meet');
                }
              }

              if (fieldsFilters[field.label].length === 0) {
                delete fieldsFilters[field.label];
              }
            }
          });

          filters[item.form_name] = {};

          if(item.hasOwnProperty('isNull')) {
            filters[item.form_name]['isNull'] = item.isNull;
            self.noFilters = false;
          }

          if (Object.keys(fieldsFilters).length !== 0) {
            filters[item.form_name]['fieldsFilters'] = fieldsFilters;
            self.noFilters = false;
          }

        });

        if (Object.keys(filters).length === 0) {
          filters = [];
        }

        return filters;
      }
    },
    watch: {
      reportData: function() {
        this.reportForms = this.getReportForms(this.reportData);
        this.reportFilters = this.getReportFilters(this.reportData);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .forms-and-filters {
    overflow: hidden;
  }
  .accordion {
    float: left;
    margin-right: 20px;
    min-width: 300px;
  }
</style>



// WEBPACK FOOTER //
// ReportFormsAndFilters.vue?a2a14826